import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MealModel } from 'src/app/nutrigenic/models/home/meal-model';
import { PlanService } from 'src/app/nutrigenic/services/plan/plan.service';
import { UserProfileService } from 'src/app/nutrigenic/services/profile/user-profile.service';
import { ResizeDetectionService } from 'src/app/nutrigenic/services/resize-detection.service';
import { Notify } from 'notiflix/build/notiflix-notify-aio';

@Component({
  selector: 'app-edit-week-plan',
  templateUrl: './edit-week-plan.component.html',
  styleUrls: ['./edit-week-plan.component.scss']
})
export class EditWeekPlanComponent {
  isTablet: boolean = false;
  isMobile: boolean = false;
  isDesktop: boolean = false;

  mealPopUpVisibility: boolean = false;
  makeOwnMealPopupVisibility: boolean = false;
  warningPopupVisibility: boolean = false;
  donePopupVisibility: boolean = false;
  checkClosingVisibility: boolean = false;
  loading: boolean = true;
  loading_first: boolean = true;
  order: any;
  curr_week: number = 0;
  currWeek: number = 0;
  editType: string = 'meals';
  selectedAllWeeks: boolean = true;
  selectedCategory: any = {id: 0, name: "All"};
  search: string = '';
  searchIcon = true;
  diff_meals:number = 0;
  diff_meals_array:any = [];
  tot_meals_array:any = [];
  count:number = 0;
  selectedMealsTrigger: boolean = false;
  selectedTag: number = 4;
  AddedMealsWeek: any= [];
  allWeekMeals: any = [];
  dialogWidth: string;
  mealsModel:any = [];
  filteredMeals: MealModel[] = [];
  visualWeekMeals:any = [];
  fatLossMeals:any = [];
  generalHealthMeals:any = [];
  buildMuscleMeals:any = [];
  breakfastMeals:any = [];
  maxSameMealTypeCount:number = 5;

  tabItems: any[] = [];
  

  constructor(
    private route: ActivatedRoute,
    private sizedetection: ResizeDetectionService,
    private planService: PlanService,
    private profileService: UserProfileService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }


  ngOnInit() {

    // Size Detection
    this.sizedetection.refreshSize();
    this.sizedetection.sizeCondition$.subscribe(data => {
      this.isDesktop = data.isDesktop;
      this.isTablet = data.isTablet;
      this.isMobile = data.isMobile;
      if (!this.isMobile) this.dialogWidth = '35%';
      else this.dialogWidth = '90%';
    });
    this.spinner.show();
    this.route.queryParams.subscribe((params: any) => {
      this.curr_week = params.week;
      this.currWeek = this.curr_week;
      this.editType = params.type || 'meals';
      this.profileService.getCurrWeekOrder(params.id).subscribe({ 
          next: (res) => {
            this.order = res.body.order;

            this.getMeals({exclude_allergies_ids: JSON.stringify(this.order.allergies.map((allergy: any) => allergy.id))});
            this.planService.getMealTags(this.isAddons() ? 'addon' : 'meal').subscribe((tags: any) => {
              this.tabItems = tags;
            });
            this.spinner.hide();
          },
          error: error => {
            this.spinner.hide();
            this.loading = false;
            this.handleError(error);
          }
      });
      this.loading_first = false;
    });
  }

  getMeals(query:any) {
    this.mealsModel = [];
    this.allWeekMeals = [];
    this.visualWeekMeals = [];
    this.fatLossMeals = [];
    this.generalHealthMeals = [];
    this.buildMuscleMeals = [];
    this.breakfastMeals = [];

    const mealsObservable = this.isAddons()
      ? this.planService.getMealAddons()
      : this.planService.getMeals(query);

    mealsObservable.subscribe((meals:  MealModel[]) => {
      this.mealsModel = meals;
      //console.log(this.mealsModel);
      this.filteredMeals = this.mealsModel;
      let new_meals:any = [];

      this.filteredMeals.forEach((meal:any) => {
        let new_meal:any = {};
        new_meal.id = meal.id;
        new_meal.name = meal.name;
        new_meal.description = meal.description;
        new_meal.type = meal.type;
        new_meal.is_master_meal = meal.is_master_meal;
        new_meal.photo_path = meal.photo_path;
        new_meal.energyKcal = meal.energyKcal;
        new_meal.protein = meal.protein;
        new_meal.fat = meal.fat;
        new_meal.availableCarbohydrate = meal.availableCarbohydrate;
        new_meal.sugars = meal.sugars;
        new_meal.sodium = meal.sodium;
        new_meal.salt = meal.salt;
        new_meal.categoryId = meal.categoryId;
        new_meal.categoryKey = meal.categoryKey;
        new_meal.categoryName = meal.categoryName;
        new_meal.categories = meal.categories;
        new_meal.categories_meals = meal.categories_meals;
        new_meal.labels = meal.labels;
        new_meal.alergies = meal.alergies;
        new_meal.quid = meal.quid;
        new_meal.price = meal.price;
        new_meal.week = 1;
        new_meal.count = 1;
        new_meal.isAdded = false;
        new_meal.show_nutrients = true;
        new_meals.push(new_meal);
      });

      this.allWeekMeals = new_meals;
      
      this.visualWeekMeals = this.allWeekMeals;

      this.loading = false;

      this.calcoloQuantita();
    });
    
  }


  updateOrderDetails() {
    this.spinner.show();
    const mealType = this.isAddons() ? 'addon' : 'meal';
    if(!this.selectedAllWeeks && this.curr_week > 1){
      this.profileService.replaceCurrWeekMeals({order_id: this.order.id, week: this.curr_week, meals: this.AddedMealsWeek}, mealType)
          .subscribe({
            next: () => {
              //console.log(res);
              this.checkClosingVisibility = false;
              this.mealPopUpVisibility = !this.mealPopUpVisibility;
              this.donePopupVisibility = true;
              this.spinner.hide();
          },
        error: error => {
            this.spinner.hide();
            this.handleError(error)
        }
      });
    } else {
      this.profileService.replaceOrderMealsFromWeek({order_id: this.order.id, week: this.curr_week, meals: this.AddedMealsWeek}, mealType)
      .subscribe({ 
        next: () => {
          //console.log(res);
          this.checkClosingVisibility = false;
          this.mealPopUpVisibility = !this.mealPopUpVisibility;
          this.donePopupVisibility = true;
          this.spinner.hide();
        },
        error: error => {
            this.spinner.hide();
            this.handleError(error)
        }
      });
    }
  }

  getExpectedMealsWeeklyTotalCount() {
    return this.order.days_per_week * this.order.meals_per_day;
  }

  calcoloQuantita(){
    // Calcolo quantità
    this.count = 0;
    this.AddedMealsWeek.forEach((added:any) => {
      this.count += added.count;
    });
    this.diff_meals = this.order.meals_per_day * this.order.days_per_week - this.count;
    this.tot_meals_array = [];
    for (let index = 0; index < this.count; index++) {
      this.tot_meals_array.push(1);
    }
    this.diff_meals_array = [];
    for (let index = 0; index < this.diff_meals; index++) {
      this.diff_meals_array.push(1);
    }
  }

  decreaseCount(meal: MealModel) {
    let id = meal.id
    this.allWeekMeals.forEach((item: MealModel) => {
      if (item.id == id) {
        if (item.count == 1) {
          this.removeMeal(item);
        } else {
          item.count = item.count - 1;
          this.visualWeekMeals.find((item: any) => item.id == id).count = item.count;
        }
      }
    });
    
    this.calcoloQuantita();
  }

  increaseCount(meal: MealModel) {
    let id = meal.id
    
    if (this.diff_meals > 0) {
      this.allWeekMeals.forEach((item: MealModel) => {
        if (item.id == id){
          if(item.count < this.maxSameMealTypeCount){
            item.count = item.count + 1;
            item.isAdded = true;
            item.show_nutrients = false;

            this.visualWeekMeals.find((item: any) => item.id == id).count = item.count;
            this.visualWeekMeals.find((item: any) => item.id == id).isAdded = item.isAdded;
            this.visualWeekMeals.find((item: any) => item.id == id).show_nutrients = item.show_nutrients;
          }
        }
          
      });
      
      this.calcoloQuantita();
    }
  }

  removeMeal(meal: MealModel) {
    let id = meal.id
    this.allWeekMeals.find((item: any) => item.id == id).count = 0;
    this.allWeekMeals.find((item: any) => item.id == id).isAdded = false;
    this.allWeekMeals.find((item: any) => item.id == id).show_nutrients = true;
    
    this.visualWeekMeals.find((item: any) => item.id == id).count = 0;
    this.visualWeekMeals.find((item: any) => item.id == id).isAdded = false;
    this.visualWeekMeals.find((item: any) => item.id == id).show_nutrients = true;

    this.AddedMealsWeek = this.AddedMealsWeek.filter((item: any) => item.id != id);
    this.calcoloQuantita();
  }

  addMeal(meal: MealModel) {
    if (this.getTotalElements() >= this.getExpectedMealsWeeklyTotalCount()) {
          let error: any = {
              "message": 'Cannot add more meals'
          }
          this.handleError(error);
      } else {
        let id = meal.id
        this.allWeekMeals.find((item: any) => item.id == id).count = 1;
        this.allWeekMeals.find((item: any) => item.id == id).isAdded = true;
        this.allWeekMeals.find((item: any) => item.id == id).show_nutrients = false;
        this.AddedMealsWeek = this.allWeekMeals.filter((item: any) => item.isAdded == true);
        this.visualWeekMeals.find((item: any) => item.id == id).count = 1;
        this.visualWeekMeals.find((item: any) => item.id == id).isAdded = true;
        this.visualWeekMeals.find((item: any) => item.id == id).show_nutrients = false;
        this.calcoloQuantita();
      }
  }

  getTotalElements() {
    let total_elements = 0;
    this.allWeekMeals.forEach((added:any) => {
      if (added.isAdded == true) {
        total_elements += added.count;
      }
    })
    return total_elements;
  }

  getTotalElementsWeek() {
    let total_elements = 0;
    if (this.allWeekMeals.length>0) {
      this.allWeekMeals.forEach((all:any) => {
        if (all.isAdded == true) {
          total_elements += all.count;
        }
      })
    }
    return total_elements;
  }


  handleError(error: any): void {
      console.error('Edit Meal Error:', error);
      if(error.error && error.error.type && error.error.type === 'validation'){
          let errors = error.error.message;
          Object.entries(errors).forEach(([key, value]) => {
              console.log(key, value);
              error = (value as string[])[0];
              Notify.failure(error, {
                  position: 'right-top',
                  timeout: 3000
              });
          });
      } else {
          error = error.message ?? 'Internal error - Could not complete the operation';
              Notify.failure(error, {
              position: 'right-top',
              timeout: 3000
          });
      }
  }


  onMealsSearchChange(filteredMeals: MealModel[]){
        this.updateMealsOnPage(filteredMeals);
    }


    resetSearch() {
        this.updateMealsOnPage();
    }

    updateMealsOnPage(mealsToUpdate: MealModel[] = this.allWeekMeals){
        this.visualWeekMeals = JSON.parse(JSON.stringify(mealsToUpdate)); // deep cloning the list // reset the meals to original list so that i can apply the changes from oneWeekMeals
    }
  
  showCheckoutDetails(item: string) {
    if (item == 'selectedMeals')
      this.selectedMealsTrigger = !this.selectedMealsTrigger;
  }

  closeConfirm() {
    this.donePopupVisibility = false;
    this.router.navigate(['/account/orders'], { queryParams: { orderId: this.order.id } });
  }

  isAddons(): boolean {
    return this.editType === 'addons';
  }

}
